import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colors } from 'utils/colors';
import { formatNum, isQuoteMedia } from 'utils/helpers';
import { Flag, Icon } from 'semantic-ui-react';
import { translation as translationTools } from '../../Translation/tools';

class AccountSelector extends Component {
  selectAccount = (index) => {
    const { accounts, changeAccount } = this.props;
    changeAccount(accounts[index]);
  };

  render() {
    const { accounts, checked, isAccount, french, partnerName } = this.props;
    const language = french ? 'fr' : 'en';
    const translateEnding = isQuoteMedia(partnerName)
      ? 'PORTFOLIO_REALLOCATE_QM'
      : 'PORTFOLIO_REALLOCATE';

    return (
      <div>
        {accounts.length > 0 ? (
          <AccountList>
            {accounts.map((account, index) => (
              <AccountCard
                key={index}
                isActive={checked.some((ind) => ind === index)}
                onClick={() => this.selectAccount(index)}
                isAccount={isAccount}
              >
                <AccountHeader>
                  <h3>{account.user_institution || account.name}</h3>
                  <div
                    style={{
                      width: '62px',
                    }}
                  >
                    {isAccount ? (
                      <Flag
                        name={account.currency === 'USD' ? 'us' : 'ca'}
                        style={{
                          transform: 'translateY(2px) scale(1.4)',
                          marginLeft: '0.5rem',
                        }}
                      />
                    ) : (
                      <Icon
                        name="briefcase"
                        style={{
                          transform: 'scale(1.4)',
                          marginLeft: '0.5rem',
                          color: colors.black,
                        }}
                      />
                    )}{' '}
                    <Icon
                      name={
                        checked.some((ind) => ind === index)
                          ? 'check square'
                          : 'square outline'
                      }
                      className="checkbox"
                      size="large"
                    />
                  </div>
                </AccountHeader>
                <p>{account.label || account.description || 'N/A'}</p>
                <p>
                  {account.updated_on
                    ? `Last updated on ${account.updated_on}`
                    : formatNum(account.balance, '$')}
                </p>
              </AccountCard>
            ))}
          </AccountList>
        ) : (
          <p style={{ textAlign: 'left', paddingLeft: '1rem' }}>
            {isAccount
              ? translationTools[language][translateEnding].LIST_NO_ACCOUNT
              : translationTools[language][translateEnding].LIST_NO_PORT}
          </p>
        )}
      </div>
    );
  }
}

const AccountList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const AccountCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  border: 2px solid
    ${({ isActive, isAccount }) =>
      isActive ? (isAccount ? colors.red : colors.blue) : colors.lightGrey};
  border-radius 10px;
  cursor: pointer;
  width: 47%;
  padding: 1rem;
  margin: 1rem;
  :hover {
    border: 2px solid ${({ isAccount }) =>
      isAccount ? 'rgba(244,94,90, 0.5)' : 'rgba(108,135,252,0.5)'};
  }
`;

const AccountHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

AccountSelector.propTypes = {
  accounts: PropTypes.array.isRequired,
  changeAccount: PropTypes.func.isRequired,
  checked: PropTypes.array.isRequired,
  isAccount: PropTypes.bool,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
};
AccountSelector.defaultProps = {
  isAccount: false,
  french: false,
  partnerName: '',
};

export default connect((state) => ({
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
}))(AccountSelector);
